/* eslint-disable react/jsx-filename-extension */
import React, { FC, useContext, CSSProperties } from 'react';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDragLayer, XYCoord, } from 'react-dnd';
import { Item, ItemKind, } from './types';
import { getStaticPropsOfSelectedItemRowByItem } from './SelectedColumns';
import { removeTextKey } from './utils/text';
import { ItemRow } from './ItemRow';

interface DragLayerContainerProps {
  currentOffset: XYCoord | null,
}

const layerStyles: CSSProperties = {
  position: 'fixed',
  pointerEvents: 'none',
  zIndex: 100,
  left: 0,
  top: 0,
  width: '100%',
  height: '100%',
};

const DragLayerItemContainer: FC<DragLayerContainerProps> = (props) => {
  const { children, currentOffset } = props;
  if (!currentOffset) { return null; }
  const { x, y } = currentOffset;
  return (<div className="drag-layer-container" style={{ ...layerStyles, transform: `translate(${x}px, ${y}px)` }}>
    {children}
          </div>);
};

interface DragLayerProps { }
export const DragLayerPreview: FC<DragLayerProps> = () => {
  const { item, isDragging, currentOffset } = useDragLayer(monitor => ({
    item: monitor.getItem() as Item,
    isDragging: monitor.isDragging(),
    currentOffset: monitor.getSourceClientOffset(),
  }));
  const i18n = useContext(I18nContext) as any;
  if (!isDragging) { return null; }

  switch (item.kind) {
    case ItemKind.selected:
      return (<DragLayerItemContainer currentOffset={currentOffset}>
        <ItemRow {...getStaticPropsOfSelectedItemRowByItem(item, i18n, { removeTextKey })} />
              </DragLayerItemContainer >);
    default:
      return null;
  }
};
